import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  getBudgetThresholdClass,
  getBudgetUsagePercentage,
} from '../../../core/constants/common-function.util';
import { ConfigurationService } from 'src/app/modules/configuration/services/configuration.service';
import { FORM_STATUS } from 'src/app/modules/form-design/constants/forms-listing.constants';
import { SegmentStatus } from 'src/app/modules/segments/interfaces/segment-list-response.interface';
import * as moment from 'moment';
import { SchedulerStatus } from 'src/app/modules/campaign-scheduler/interfaces/scheduler-listing-response.interface';
import { CampaignStatus } from 'src/app/modules/campaigns/interfaces/campaign-list-response.interface';
import { ITemplateFilteredData } from 'src/app/modules/templates/interfaces/template-list-response.interface';
import { parseDate, TemplateStatus } from 'src/app/core/constants/common';
import { SegmentType } from 'src/app/modules/campaign-scheduler/interfaces/schedule-campaign.interface';
import { ChannelType } from 'src/app/modules/templates/interfaces/create-template.interface';
import {
  NUMBER_FIFTY_NINE,
  NUMBER_NINE_HUNDRED_NINTY_NINE,
  NUMBER_TWENTY_THREE,
} from 'src/app/core/constants/number';

@Injectable({
  providedIn: 'root',
})
export class GridService {
  format = {
    dashDateFormat: 'DD-MM-YYYY',
    spaceDateFormat: 'DD MMM YYYY',
    dashDateTimeFormat: 'DD-MM-YYYY HH:mm',
  };

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigurationService,
  ) {}

  getGridData(url: string, payload: any) {
    return this.http.post(url, payload);
  }

  getGridData1(url: string, payload: any) {
    return this.http.post(url, payload);
  }

  processWabaListing(data: any[]) {
    const wabaMasterConfig = this.configService.getWabaMasterMap();
    return this.prePareWabaListData(
      data,
      wabaMasterConfig.bspMap,
      wabaMasterConfig.wabaTypeMap,
    );
  }

  prePareWabaListData(
    data: any[],
    bspMap: { [key: string]: string },
    wabaTypeMap: { [key: string]: string | { [key: string]: string } },
  ) {
    const subTypeMap: { [key: string]: string } = wabaTypeMap[
      'wabaSubTypeMap'
    ] as { [key: string]: string };
    for (const obj of data) {
      obj.bspStr = bspMap[obj.bsp] ? bspMap[obj.bsp] : obj.bsp;
      obj.typeStr = wabaTypeMap[obj.type] ? wabaTypeMap[obj.type] : obj.type;
      obj.subTypeStr =
        obj.subType && subTypeMap[obj.subType]
          ? subTypeMap[obj.subType]
          : obj.subType;

      if (obj.statusReason) {
        let tooltipText;
        if (obj.active) {
          tooltipText = `<b>Reason of Reactivation</b> <br> <span> ${obj.statusReason}</span>`;
        } else {
          tooltipText = `<b>Reason of Deactivation</b> <br> <span> ${obj.statusReason}</span>`;
        }
        obj.statusInfo = tooltipText;
      }
      if (obj.active) {
        obj.statusStr = 'Active';
        obj.isTestView = true;
        obj.statusColClasses = ' executed-status ';
        obj.isCopyView = true;
        if (!obj.defaultStatus) {
          obj.isDeactivateView = true;
        }
      } else {
        obj.statusStr = 'Inactive';
        obj.isReactivateView = true;
        obj.statusColClasses = ' failed-text ';
      }
    }
    return data;
  }

  processFormListing(data: any[]) {
    for (const obj of data) {
      if (obj.reason) {
        obj.statusInfo = `<b>Reason of De-Comission</b> <br> <span> ${obj.reason}</span>`;
      }
      obj.isPreviewView = true;
      if (obj.formStatus === FORM_STATUS.DECOMMISIONED) {
        obj.statusColClasses = ' failed-text ';
      } else if (obj.formStatus === FORM_STATUS.PUBLISHED) {
        obj.isDecommissionedView = true;
        obj.isCopyView = true;
        obj.statusColClasses = ' publish-status ';
      } else if (obj.formStatus === FORM_STATUS.DRAFT) {
        obj.isConfigureView = true;
        obj.isDeleteView = true;
        obj.statusColClasses = ' draft-status ';
      } else if (obj.formStatus === FORM_STATUS.INPROGRESS) {
        obj.statusColClasses = ' inprogress-status ';
      }
    }
    return data;
  }

  processSegmentListing(data: any[]) {
    for (const obj of data) {
      switch (obj.status) {
        case SegmentStatus.CREATED:
          obj.statusColClasses = ' created-status ';
          break;
        case SegmentStatus.EXECUTED:
          obj.statusColClasses = ' executed-status ';
          break;
        case SegmentStatus.FAILED:
        case SegmentStatus.SCRUBBING_FAILED:
        case SegmentStatus.EXTRACTION_FAILED:
        case SegmentStatus.CANCELLED:
        case SegmentStatus.INVALID:
          obj.statusColClasses = ' failed-text ';
          break;
        case SegmentStatus.IN_PROGRESS:
        case SegmentStatus.PAUSED:
          obj.statusColClasses = ' inprogress-status ';
          break;
        case SegmentStatus.SCHEDULED:
          obj.statusColClasses = ' scheduled-status ';
          break;
        case SegmentStatus.MAPPED:
          obj.statusColClasses = ' blue-text ';
          break;
        case SegmentStatus.SCRUBBING:
        case SegmentStatus.TRANSFORMING:
        case SegmentStatus.EXTRACTING:
          obj.statusColClasses = ' dark-blue-text ';
          break;
        case SegmentStatus.EXTRACTED:
          obj.statusColClasses = ' green-text ';
          break;
        case SegmentStatus.SCRUBBED:
          obj.statusColClasses = ' light-green-text ';
          break;
        case SegmentStatus.CAMPAIGN_RESCHEDULED:
          obj.statusColClasses = ' orange-text ';
          break;
        default:
          break;
      }
    }
    return data;
  }

  processSchedulerListing(data: any[]) {
    const dateFormat = 'DD/MM/YYYY HH:mm';

    for (const obj of data) {
      obj.isCancelView = false;
      obj.isPauseView = false;
      obj.isResumeView = false;
      obj.isRescheduleView = false;
      obj.statusStr = obj.status;

      if (obj.totalBudget) {
        const percentage = getBudgetUsagePercentage({
          totalBudget: obj.totalBudget,
          reservedAmount: obj.reservedAmount,
          refundedAmount: obj.refundedAmount,
          maxBudgetPercentage: obj.maxBudgetPercentage,
        });
        obj.budgetThreshold = `${Math.max(0, percentage).toFixed(2)}%`;
        obj.budgetThresholdClass = getBudgetThresholdClass(
          Math.max(0, percentage),
        );
      } else {
        obj.budgetThreshold = '0.00%';
        obj.budgetThresholdClass = ' draft-status ';
      }

      if (!obj.frequency) {
        // manual cancel/reschedule
        if (
          [
            SchedulerStatus.SCHEDULED,
            SchedulerStatus.RESCHEDULED,
            SchedulerStatus.RESCHEDULING_FAILED,
            SchedulerStatus.PAUSED,
          ].includes(obj.status) &&
          this.isDateAfterTodayBeforeFifteenMinutes(
            obj.executionStartDate,
            dateFormat,
          )
        ) {
          obj.isCancelView = true;
          obj.isRescheduleView = true;
        }
      } else if (obj.segmentType === SegmentType.AUTOMATED && obj.frequency) {
        // recurring cancel/ pause
        if (
          [
            SchedulerStatus.SCHEDULED,
            SchedulerStatus.RESCHEDULED,
            SchedulerStatus.TO_BE_SCHEDULED,
          ].includes(obj.status) &&
          this.isDateAfterTodayBeforeFifteenMinutes(
            obj.executionStartDate,
            dateFormat,
          )
        ) {
          obj.isCancelView = true;
          obj.isPauseView = true;
        } else if (
          [
            SchedulerStatus.FAILED,
            SchedulerStatus.EXECUTED,
            SchedulerStatus.INVALID_SEGMENT,
            SchedulerStatus.SCHEDULING_FAILED,
            SchedulerStatus.SCHEDULED,
          ].includes(obj.status) &&
          this.isDateSameOrBeforeToday(obj.executionStartDate, dateFormat) &&
          this.isDateSameOrAfterToday(obj.executionEndDate, dateFormat)
        ) {
          const flag = this.isActionBetweenExecutionTime(
            obj.executionStartDate,
          );
          obj.isCancelView = flag;
          obj.isPauseView = flag;
        }
        // recurring resume
        if (SchedulerStatus.PAUSED === obj.status) {
          if (
            this.isDateAfterTodayBeforeFifteenMinutes(
              obj.executionStartDate,
              dateFormat,
            )
          ) {
            obj.isResumeView = true;
            obj.isCancelView = true;
          } else if (
            this.isDateSameOrBeforeToday(obj.executionStartDate, dateFormat) &&
            this.isDateSameOrAfterToday(obj.executionEndDate, dateFormat)
          ) {
            const flag = this.isActionBetweenExecutionTime(
              obj.executionStartDate,
            );
            obj.isResumeView = flag;
            obj.isCancelView = flag;
          }
        }

        // recurring reschedule
        if (
          [
            SchedulerStatus.SCHEDULED,
            SchedulerStatus.RESCHEDULED,
            SchedulerStatus.TO_BE_SCHEDULED,
            SchedulerStatus.PAUSED,
          ].includes(obj.status) &&
          this.isDateAfterTodayBeforeFifteenMinutes(
            obj.executionStartDate,
            dateFormat,
          )
        ) {
          obj.isRescheduleView = true;
        } else if (
          [
            SchedulerStatus.FAILED,
            SchedulerStatus.EXECUTED,
            SchedulerStatus.INVALID_SEGMENT,
            SchedulerStatus.PAUSED,
            SchedulerStatus.SCHEDULING_FAILED,
            SchedulerStatus.SCHEDULED,
          ].includes(obj.status) &&
          this.isDateSameOrBeforeToday(obj.executionStartDate, dateFormat) &&
          this.isDateSameOrAfterToday(obj.executionEndDate, dateFormat)
        ) {
          obj.isRescheduleView = this.isActionBetweenExecutionTime(
            obj.executionStartDate,
          );
        }
      }
      if (obj.budgetExhausted) {
        obj.statusStr = 'Budget Exhausted';
        obj.statusColClasses = ' failed-text ';
        obj.isCancelView = false;
        obj.isPauseView = false;
        obj.isResumeView = false;
        obj.isRescheduleView = false;
      }

      if (obj.campaignStartDate) {
        obj.campaignStartDateStr = moment(
          obj.campaignStartDate,
          this.format.dashDateFormat,
        ).format(this.format.spaceDateFormat);
      }

      if (obj.campaignEndDate) {
        obj.campaignEndDateStr = moment(
          obj.campaignEndDate,
          this.format.dashDateFormat,
        ).format(this.format.spaceDateFormat);
      }

      if (obj.executionStartDate) {
        obj.executionStartDateStr = moment(
          obj.executionStartDate,
          'DD-MM-YYYY HH:mm',
        ).format('DD MMM YYYY HH:mm');
      }

      // if (obj.executionEndDate) {
      //   obj.executionEndDateStr = moment(
      //     obj.executionEndDate,
      //     'DD-MM-YYYY HH:mm'
      //   ).format('DD MMM YYYY HH:mm');
      // }

      if (obj.lastExecutedOn) {
        obj.lastExecutedOnStr = moment(
          obj.lastExecutedOn,
          this.format.dashDateFormat,
        ).format(this.format.spaceDateFormat);
      }

      const parsedStart = parseDate(obj.executionStartDate, dateFormat);
      if (parsedStart) {
        obj.formattedExecutionDate = parsedStart.toLocaleString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        });
        obj.formattedExecutionTime =
          parsedStart
            .toLocaleString('en-IN', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })
            .replace(/am/i, 'AM')
            .replace(/pm/i, 'PM') + ' IST';
      } else {
        obj.formattedExecutionDate = obj.executionStartDate || '';
        obj.formattedExecutionTime = '';
      }

      switch (obj.status) {
        case SchedulerStatus.IN_PROGRESS:
        case SchedulerStatus.PAUSED:
        case SchedulerStatus.TO_BE_SCHEDULED:
          obj.statusColClasses = ' inprogress-status ';
          break;
        case SchedulerStatus.EXECUTED:
          obj.statusColClasses = ' executed-status ';
          break;
        case SchedulerStatus.SCHEDULED:
        case SchedulerStatus.RESCHEDULED:
          obj.statusColClasses = ' scheduled-status ';
          break;
        case SchedulerStatus.RESCHEDULING_FAILED:
        case SchedulerStatus.FAILED:
        case SchedulerStatus.CANCELLED:
        case SchedulerStatus.SCHEDULING_FAILED:
        case SchedulerStatus.UNSCHEDULING_FAILED:
        case SchedulerStatus.INVALID_SEGMENT:
          obj.statusColClasses = ' failed-text ';
          break;
        default:
          break;
      }
    }
    return data;
  }

  processCampaignListing(data: any[]) {
    for (const obj of data) {
      obj.statusStr = obj.status;
      if (obj.startDate) {
        obj.startDateStr = moment(
          obj.startDate,
          this.format.dashDateFormat,
        ).format(this.format.spaceDateFormat);
      }
      if (obj.endDate) {
        obj.endDateStr = moment(obj.endDate, this.format.dashDateFormat).format(
          this.format.spaceDateFormat,
        );
      }

      if (obj.totalBudget) {
        const percentage = getBudgetUsagePercentage({
          totalBudget: obj.totalBudget,
          reservedAmount: obj.reservedAmount,
          refundedAmount: obj.refundedAmount,
          maxBudgetPercentage: obj.maxBudgetPercentage,
        });
        obj.budgetThreshold = `${Math.max(0, percentage).toFixed(2)}%`;
        obj.budgetThresholdClass = getBudgetThresholdClass(
          Math.max(0, percentage),
        );
      } else {
        obj.budgetThreshold = '0.00%';
        obj.budgetThresholdClass = ' draft-status ';
      }

      obj.isEditView = true;
      if (obj.status === CampaignStatus.DRAFT) {
        obj.isDeleteView = true;
        obj.statusColClasses = ' inprogress-status ';
      } else if (obj.status === CampaignStatus.PUBLISHED) {
        if (
          obj.endDate &&
          this.isTodayFifteenMinutesBefore(
            `${obj.endDate} 23:59`,
            this.format.dashDateTimeFormat,
          )
        ) {
          obj.isEditView = false;
          obj.isCancelView = true;
          obj.isRescheduleView = true;
          obj.isPauseView = true;
        }
        obj.statusColClasses = ' executed-status ';
        obj.isDeleteView = false;
        if (obj.budgetExhausted) {
          obj.statusStr = 'Budget Exhausted';
          obj.statusColClasses = ' failed-text ';
          obj.isEditView = false;
        }
      }
    }
    return data;
  }

  processFileUploadListing(data: any[]) {
    for (const obj of data) {
      if (obj.communicationChannel === 'WHATSAPP') {
        obj.channel = 'WhatsApp';
        obj.channelIconSrc = 'preview/whatsapp_icon.svg';
      } else if (obj.communicationChannel === 'SMS') {
        obj.channel = 'SMS';
        obj.channelIconSrc = 'preview/sms_icon.svg';
      }
    }
    return data;
  }

  processTemplateListing(filteredResponse: ITemplateFilteredData[]) {
    filteredResponse.forEach((rowData: ITemplateFilteredData) => {
      rowData.isEditView = false;
      rowData.isPreviewView = false;
      rowData.isRetireView = false;
      rowData.isCopyView = false;
      rowData.isReactivateView = false;
      rowData.isLogsView = false;
      rowData.statusColClasses = '';
      const rowDataStatus = rowData.status?.toLowerCase();
      const rowDataChannel = rowData.channel?.toLowerCase();
      if (rowData?.statusReason) {
        let tooltipText = '';
        if (rowDataStatus === TemplateStatus.RETIRED.toLowerCase()) {
          tooltipText = 'Retiring';
        } else if (rowDataStatus === TemplateStatus.PUBLISHED.toLowerCase()) {
          tooltipText = 'Reinstating';
        }
        tooltipText = `<b>Reason of ${tooltipText} template </b> <br> <span> ${rowData?.statusReason}</span>`;
        rowData.statusInfo = tooltipText;
      }
      if (rowData.emailTemplate) {
        rowData.subject = rowData.emailTemplate.subject;
      }

      switch (rowDataChannel) {
        case ChannelType.WHATSAPP.toLowerCase():
          rowData.serviceProvider = rowData?.whatsAppTemplates?.[0]?.bspSubType;
          rowData.isLogsView =
            rowDataStatus !== TemplateStatus.DRAFT.toLowerCase() &&
            rowDataStatus !== TemplateStatus.PENDING.toLowerCase();
          rowData.bsp = rowData?.whatsAppTemplates?.[0]?.bsp;
          break;
        case ChannelType.EMAIL.toLowerCase():
          rowData.serviceProvider = rowData?.emailTemplate?.senderId;
          rowData.isLogsView =
            rowDataStatus !== TemplateStatus.DRAFT.toLowerCase() &&
            rowDataStatus !== TemplateStatus.PENDING.toLowerCase();
          break;
        case ChannelType.RCS.toLowerCase():
          rowData.bsp = rowData?.rcsTemplates?.[0]?.bsp;
          rowData.isLogsView =
            rowDataStatus !== TemplateStatus.DRAFT.toLowerCase() &&
            rowDataStatus !== TemplateStatus.PENDING.toLowerCase();
          break;
        case ChannelType.SMS.toLowerCase():
          rowData.serviceProvider = rowData?.smsTemplate?.senderId;
          rowData.isLogsView =
            rowDataStatus !== TemplateStatus.DRAFT.toLowerCase() &&
            rowDataStatus !== TemplateStatus.PENDING.toLowerCase();
          break;
        default:
          break;
      }

      switch (rowDataStatus) {
        case TemplateStatus.PUBLISHED.toLowerCase():
          if (
            rowDataChannel === ChannelType.RCS.toLowerCase() &&
            rowData?.bsp?.toLowerCase() === 'karix'
          ) {
            rowData.isEditView = false;
          } else {
            rowData.isEditView = true;
          }
          rowData.isPreviewView = true;
          rowData.isRetireView = true;
          rowData.isCopyView = true;
          rowData.statusColClasses = ' executed-status ';
          rowData.isTestView = true;
          break;
        case TemplateStatus.PENDING.toLowerCase():
          rowData.isPreviewView = true;
          rowData.isCopyView = true;
          rowData.statusColClasses = ' inprogress-status ';
          break;
        case TemplateStatus.DRAFT.toLowerCase():
          rowData.isDeleteView = true;
          rowData.isEditView = true;
          rowData.isPreviewView = true;
          rowData.statusColClasses = ' draft-status ';
          break;
        case TemplateStatus.RETIRED.toLowerCase():
          rowData.isCopyView = true;
          rowData.isReactivateView = true;
          rowData.isPreviewView = true;
          rowData.statusColClasses = ' failed-text ';
          break;
        case TemplateStatus.REJECTED.toLowerCase():
          if (rowDataChannel === 'whatsapp' || rowDataChannel === 'rcs') {
            rowData.isEditView = true;
          }
          rowData.isPreviewView = true;
          rowData.isCopyView = true;
          rowData.statusColClasses = ' failed-text ';
          break;
        default:
          break;
      }
    });
    return filteredResponse;
  }

  processSenderEmailListing(data: any[]) {
    data.forEach((obj: any) => {
      if (obj.statusReason) {
        let tooltipText;
        if (obj.active) {
          tooltipText = `<b>Reason of Reactivation</b> <br> <span> ${obj.statusReason}</span>`;
        } else {
          tooltipText = `<b>Reason of Deactivation</b> <br> <span> ${obj.statusReason}</span>`;
        }
        obj.statusInfo = tooltipText;
      }
      if (obj.active) {
        obj.statusStr = 'Active';
        obj.isTestView = true;
        obj.statusColClasses = ' executed-status ';
        obj.isCopyView = true;
        if (!obj.defaultStatus) {
          obj.isDeactivateView = true;
        }
      } else {
        obj.statusStr = 'Inactive';
        obj.isReactivateView = true;
        obj.statusColClasses = ' failed-text ';
      }
    });
    return data;
  }

  processShortenUrlListing(data: any) {
    for (const obj of data) {
      obj.isCopyView = true;
      obj.isRedirectView = true;
      const createdDate = new Date(obj.createdDate);
      const expiryDays = Number.parseInt(obj.expiryDays, 10);
      const expiryDate = new Date(createdDate);
      expiryDate.setDate(createdDate.getDate() + expiryDays);
      expiryDate.setHours(
        NUMBER_TWENTY_THREE,
        NUMBER_FIFTY_NINE,
        NUMBER_FIFTY_NINE,
        NUMBER_NINE_HUNDRED_NINTY_NINE,
      );
      obj.expiryDate =
        expiryDate.toString() === 'Invalid Date' ? null : expiryDate;
      const now = new Date();
      const isExpired = now > expiryDate;
      if (isExpired || expiryDate.toString() === 'Invalid Date') {
        obj.status = 'Expired';
        obj.statusColClasses = ' failed-text ';
      } else {
        obj.status = 'Active';
        obj.statusColClasses = ' executed-status ';
      }
    }

    return data;
  }

  isDateSameOrAfterToday(dateStr: string, format: string) {
    return moment(dateStr, format).isSameOrAfter(moment());
  }

  isDateSameOrBeforeToday(dateStr: string, format: string) {
    return moment(dateStr, format).isSameOrBefore(moment());
  }

  isDateAfterToday(dateStr: string, format: string) {
    return moment(dateStr, format).isAfter(moment());
  }

  isDateSameAsToday(dateStr: string, format: string) {
    return moment(dateStr, format).isSame(moment());
  }

  isDateAfterTodayBeforeFifteenMinutes(dateStr: string, format: string) {
    return moment(dateStr, format).subtract(15, 'minutes').isAfter(moment());
  }

  isDateBeforeToday(dateStr: string, format: string) {
    return moment(dateStr, format).isBefore(moment());
  }

  isActionBetweenExecutionTime(startDate: string): boolean {
    let flag = false;
    const startTime = startDate.split(' ')[1];

    if (moment(startTime, 'HH:mm').isAfter(moment())) {
      if (moment(startTime, 'HH:mm').subtract(1, 'hour').isAfter(moment())) {
        flag = true;
      }
    } else {
      flag = true;
    }
    return flag;
  }

  processApiSchedulerListing(data: any[], isOrchestrationSubTab = false) {
    const processedData: any[] = [];

    for (const campaign of data) {
      const baseData = {
        campaignName: campaign.campaignName,
        campaignStartDateStr: moment(
          campaign.campaignStartDate,
          this.format.dashDateFormat,
        ).format(this.format.spaceDateFormat),
        campaignEndDateStr: moment(
          campaign.campaignEndDate,
          this.format.dashDateFormat,
        ).format(this.format.spaceDateFormat),
        lastExecutionDateStr: moment(
          campaign.lastExecutionDates[0],
          this.format.dashDateFormat,
        ).format(this.format.spaceDateFormat),
        viewAnalytics: 'View',
      };

      if (campaign.totalBudget) {
        const percentage = getBudgetUsagePercentage({
          totalBudget: campaign.totalBudget,
          reservedAmount: campaign.reservedAmount,
          refundedAmount: campaign.refundedAmount,
          maxBudgetPercentage: campaign.maxBudgetPercentage,
        });
        campaign.budgetThreshold = `${Math.max(0, percentage).toFixed(2)}%`;
        campaign.budgetThresholdClass = getBudgetThresholdClass(
          Math.max(0, percentage),
        );
      } else {
        campaign.budgetThreshold = '0.00%';
        campaign.budgetThresholdClass = ' draft-status ';
      }

      if (isOrchestrationSubTab) {
        const tooltipText = `
      <table style="font-size:12px;border-collapse:collapse;border-spacing:0;width:100%;">
        <thead>
          <tr style="border-bottom:1px solid #ddd;font-weight:bold;">
            <th style="text-align:left;padding:4px 0;border:none;background:transparent;">Channel</th>
            <th style="text-align:left;padding:4px 0;border:none;background:transparent;">Template Name</th>
          </tr>
        </thead>
        <tbody>
          ${campaign.templateDetails
            .map(
              (temp: any) => `
          <tr>
            <td style="padding:4px 0;border:none;background:transparent;">${temp.channel}</td>
            <td style="padding:4px 0;font-weight:600;border:none;background:transparent;">${temp.templateName}</td>
          </tr>`,
            )
            .join('')}
        </tbody>
      </table>
      `.trim();

        processedData.push({
          ...campaign,
          ...baseData,
          templateCode: campaign.templateDetails[0].templateCode,
          templateName: 'Multiple Channels',
          templateNameInfo: tooltipText,
          channel: campaign.templateDetails[0].channel,
        });
      } else {
        for (const template of campaign.templateDetails) {
          processedData.push({
            ...campaign,
            ...baseData,
            templateCode: template.templateCode,
            templateName: template.templateName,
            channel: template.channel,
          });
        }
      }
    }

    return processedData;
  }

  isTodayFifteenMinutesBefore(dateStr: string, format: string) {
    const now = moment();
    const targetTime = moment(dateStr, format);
    return (
      now.isSame(targetTime, 'day') &&
      targetTime.diff(now, 'minutes') <= 15 &&
      targetTime.diff(now, 'minutes') >= 0
    );
  }
}
